export default "__VITE_ASSET__DZoN8AA5__"